// LuxuryPage.jsx
import React from "react";
// import "./LuxuryPage.css";
import "../App.css";
import { useEnquiryModal } from "./EnquiryModal";
// import { FaLocationDot } from "react-icons/fa6";
import { ENQUIRY_CTA } from "../constants";

const LuxuryPage = () => {
  const { openModal } = useEnquiryModal();
  return (
    <div id="about" className="luxury-page">
      {/* ----------- Section 1: Luxury Launch ----------- */}
      <section className="luxury-section">
        <div className="luxury-image">
          <img
            src="Assets/banner1.jpeg"
            alt="Luxury View"
          />
        </div>
        <div className="luxury-text">
          <h2 className="font-semibold">
            About Lyra at Ghaf Woods
          </h2>
          {/* <div className="luxury-location flex items-center">
            <FaLocationDot className="text-[#997736] mr-2" />
            <span className="text-[#997736] font-bold text-lg">Ghaf Woods, Dubai</span>
          </div> */}
          <p>
            Find a new rhythm of life with a home at Lyra. Choose a one- or two-bedroom apartment, including garden options, within Majid Al Futtaim’s Ghaf Woods community. A landscape-led setting in Dubailand brings nature into the everyday, with space to unwind, explore and connect. The tower features 349 apartments—comprising 209 one-bedroom units and 140 two-bedroom units—and is located just a short walk from Ghaf Woods Mall, Spanning approximately 738,000 square meters, the Ghaf Woods development consists of 11 clusters containing over 7,000 residential units 
          </p>
          <button onClick={() => openModal(ENQUIRY_CTA.INTRO)} className="mt-4 font-semibold border-2 rounded-md border-[#997736] text-[#997736] hover:text-white px-6 py-2 hover:bg-[#997736] transition">DOWNLOAD BROCHURE</button>
        </div>
      </section>
    </div>
  );
};

export default LuxuryPage;
